import { render, staticRenderFns } from "./grupoFolha.vue?vue&type=template&id=4c10fc68"
import script from "./grupoFolha.vue?vue&type=script&lang=js"
export * from "./grupoFolha.vue?vue&type=script&lang=js"
import style0 from "./grupoFolha.vue?vue&type=style&index=0&id=4c10fc68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports